import React from "react";
import { useTranslation } from "react-i18next";
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    IconButton,
    Box,
    SelectChangeEvent
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

interface Option {
    value: string;
    name: string;
    label?: string; // agar translation kerak bo'lmasa
}

interface FilterSelectProps {
    className?: string;
    label?: string;
    value?: string;
    setFilter: (prev: any) => any;
    name?: string;
    placeholder?: string;
    options: Option[]; // dynamic options
    translationPrefix?: string; // translation prefix (masalan: "REGION" yoki "STATUS")
    width?: string;
    size?: 'small' | 'medium';
    disabled?: boolean;
    required?: boolean;
    showClearButton?: boolean;
}

export const FilterSelect: React.FC<FilterSelectProps> = ({
    className = "",
    label,
    value = "",
    setFilter,
    name = "filter",
    placeholder = "COMMON.SELECT",
    options = [],
    translationPrefix,
    width = '200px',
    size = 'small',
    disabled = false,
    required = false,
    showClearButton = true,
}) => {
    const { t } = useTranslation();

    const changeHandler = (event: SelectChangeEvent<string>) => {
        const selectedValue = event.target.value;
        setFilter((prev: any) => ({
            ...prev,
            [name]: selectedValue === 'all' ? '' : selectedValue
        }));
    };

    const clearHandler = () => {
        setFilter((prev: any) => ({
            ...prev,
            [name]: ''
        }));
    };

    const currentValue = value || '';

    const getOptionLabel = (option: Option) => {
        if (option.label) {
            return option.label;
        }
        if (translationPrefix) {
            return t(`${translationPrefix}.${option.value}`, { defaultValue: option.name });
        }
        return option.name;
    };

    return (
        <Box className={className} sx={{ width, position: 'relative' }}>
            <FormControl fullWidth size={size} required={required} disabled={disabled}>
                {label && (
                    <InputLabel id={`${name}-select-label`}>
                        {label}
                    </InputLabel>
                )}

                <Select
                    labelId={`${name}-select-label`}
                    name={name}
                    value={currentValue}
                    onChange={changeHandler}
                    label={label}
                    size={size}
                    // sx={{
                    //     '& .MuiSelect-select': {
                    //         paddingRight: (value && showClearButton) ? '48px' : '32px',
                    //     },
                    // }}
                >
                    {options.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {getOptionLabel(option)}
                        </MenuItem>
                    ))}
                </Select>

                {value && showClearButton && !disabled && (
                    <IconButton
                        onClick={clearHandler}
                        size="small"
                        sx={{
                            position: 'absolute',
                            right: 10,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            zIndex: 10,
                            backgroundColor: 'white',
                            '&:hover': { backgroundColor: '#eee' },
                        }}
                    >
                        <ClearIcon fontSize="small" />
                    </IconButton>
                )}

            </FormControl>
        </Box>
    );
};